<template>
  <div class="user-agreement">
    <h1 class="page-title">เงื่อนไขการใช้บริการ</h1>
    <p>
      ข้อกำหนดและเงื่อนไขในการใช้งาน แอปพลิเคชั่น MOVE EV X ฉบับนี้
      (“เงื่อนไขการใช้บริการ")
      ได้ระบุถึงข้อกำหนดและเงื่อนไขในการใช้งานผลิตภัณฑ์และบริการใดๆ
      (เรียกรวมกันว่า “บริการฯ”) ของ บริษัท เอช เซม มอเตอร์ จำกัด
      บริษัทที่จัดตั้งขึ้นในราชอาณาจักรไทย และมีที่อยู่จดทะเบียนเลขที่ 9 หมู่ 3
      ต.ตานิม อ.บางปะหัน จ.พระนครศรีอยุธยา ( ในที่นี้จะเรียกว่า ‘ MOVE EV X ’
      หรือ ‘ บริษัท ’ ) แก่ผู้ใช้บริการ (ซึ่งต่อไปนี้จะเรียกว่า ‘ผู้ใช้’ หรือ
      ‘ผู้ใช้บริการ’ )
    </p>
    <h3 class="paragraph-title">1.การตกลงยอมรับข้อกำหนดและเงื่อนไขฯ ฉบับนี้</h3>
    <p>
      1.1.ผู้ใช้ทุกรายจะต้องใช้บริการฯ
      ตามข้อกำหนดที่ระบุไว้ในข้อกำหนดและเงื่อนไขฯ ฉบับนี้
      โดยผู้ใช้จะไม่สามารถใช้บริการฯ
      ได้เว้นเสียแต่ผู้ใช้ได้ตกลงยอมรับข้อกำหนดและเงื่อนไขฯ ฉบับนี้แล้ว
    </p>
    <p>
      1.2.หากผู้ใช้ดังกล่าวใช้บริการฯ
      ในนามหรือเพื่อวัตถุประสงค์ขององค์กรธุรกิจใด
      ให้ถือว่าองค์กรธุรกิจดังกล่าวได้ตกลงยอมรับข้อกำหนดและเงื่อนไขฯ
      ฉบับนี้แล้วล่วงหน้า
    </p>
    <p>
      1.3.หากมีข้อกำหนดและเงื่อนไขฯ เพิ่มเติมใดๆ ซึ่งเกี่ยวข้องกับการให้บริการฯ
      ผู้ใช้จะต้องปฏิบัติตามข้อกำหนดและเงื่อนไขฯ
      เพิ่มเติมดังกล่าวเช่นเดียวกับข้อกำหนดและเงื่อนไขฯ ในการใช้งานฉบับนี้
    </p>
    <p>
      ในการใช้งานฉบับน
    </p>
    <h3 class="paragraph-title">2. การแก้ไขข้อกำหนดและเงื่อนไขฯ ฉบับนี้</h3>
    <p>
      MOVE EV X อาจเปลี่ยนแปลงแก้ไขข้อกำหนดและเงื่อนไขฯ
      ฉบับนี้ได้ตลอดเวลาตามที่
      บริษัทเห็นสมควรซึ่งจะอยู่ภายใต้ขอบวัตถุประสงค์ของข้อกำหนดและเงื่อนไขฯ
      ฉบับนี้ ในกรณีดังกล่าว
      บริษัทจะแจ้งเนื้อหาของข้อกำหนดฉบับแก้ไขรวมถึงวันที่มีผลบังคับใช้บนแอปพลิเคชั่น
      MOVE EV X หรืออาจแจ้งให้ผู้ใช้ทราบด้วยวิธีการอื่นใดตามที่ บริษัท กำหนด
      ทั้งนี้ ข้อกำหนดและเงื่อนไขฉบับแก้ไขจะมีผลบังคับใช้ตามวันที่กำหนดต่อไป
    </p>
    <h3 class="paragraph-title">3.บัญชี</h3>
    <p>
      3.1.เมื่อใช้บริการฯ ผู้ใช้อาจมีความจำเป็นต้องลงทะเบียนการใช้บริการฯ
      ด้วยข้อมูลบางประการ ทั้งนี้ ผู้ใช้ต้องให้ข้อมูลที่เป็นความจริง ถูกต้อง
      ครบถ้วนและมีหน้าที่ต้องปรับปรุงและแก้ไขข้อมูลดังกล่าวให้เป็นปัจจุบันอยู่เสมอ
    </p>
    <p>
      3.2.MOVE EV X ขอสงวนสิทธิในการลบบัญชีใดๆ
      ซึ่งหมดอายุสัญญาการเช่าหรือถูกยกเลิกสัญญา ทั้งนี้
      โดยไม่ต้องบอกกล่าวล่วงหน้าใดๆ แก่ผู้ใช้บัญชีดังกล่าว
    </p>
    <p>
      3.3 สิทธิใดๆ
      ของผู้ใช้บริการอาจสิ้นสุดลงเมื่อบัญชีของผู้ใช้ดังกล่าวถูกลบไม่ว่าด้วยเหตุผลประการใดๆ
      ทั้งนี้ บัญชีการใช้บริการฯ จะไม่สามารถกู้คืนได้ถึงแม้ว่าผู้ใช้บริการฯ
      จะลบบัญชีของตนโดยไม่ได้ตั้งใจก็ตาม
    </p>
    <p>
      3.4 บัญชีแต่ละบัญชีในการใช้บริการฯ นั้น
      มีไว้เพื่อการใช้งานเฉพาะบุคคลและเป็นของเจ้าของบัญชีนั้นแต่เพียงผู้เดียว
      ผู้ใช้ไม่สามารถโอน ให้ยืม หรือจำหน่ายสิทธิในการใช้บัญชีของตนแก่บุคคลภายนอก
      ขณะเดียวกันบุคคลภายนอกก็ไม่สามารถรับช่วงสิทธิหรือสืบทอดบัญชีจากผู้ใช้ดังกล่าวได้เช่นกัน
    </p>
    <h3 class="paragraph-title">4.การให้บริการฯ</h3>
    <p>
      4.1 ผู้ใช้จะเป็นผู้รับผิดชอบจัดหาอุปกรณ์สื่อสารเคลื่อนที่ สมาร์ทโฟน
      อุปกรณ์สื่อสารอื่นๆ ระบบปฏิบัติการ วิธีการเชื่อมต่อสื่อสารและกระแสไฟฟ้า
      ฯลฯ ซึ่งจำเป็นต่อการใช้บริการฯ ทั้งนี้
      ผู้ใช้เป็นผู้ออกค่าใช้จ่ายเองทั้งสิ้น
    </p>
    <p>
      4.2 MOVE EV X ขอสงวนสิทธิในการแก้ไขหรือเปลี่ยนแปลงข้อกำหนดและเงื่อนฯ
      ในการใช้บริการทั้งหมดหรือแต่บางส่วนไม่ว่าในเวลาใด ตามที่ MOVE EV X
      เห็นสมควร ทั้งนี้ โดยไม่ต้องบอกกล่าวล่วงหน้าแก่ผู้ใช้
    </p>
    <p>
      4.3 MOVE EV X อาจหยุดการให้บริการฯ
      ทั้งหมดหรือแต่บางส่วนโดยไม่ต้องบอกกล่าวล่วงหน้าแก่ผู้ใช้ในกรณีดังต่อไปนี้
    </p>
    <p>
      (1)เมื่อทำการบำรุงรักษาหรือซ่อมแซมระบบ
    </p>
    <p>
      (2)เมื่อไม่สามารถให้บริการได้เนื่องจากเหตุสุดวิสัยบางประการ เช่น
      อุบัติเหตุ (ไฟไหม้ไฟดับ ฯลฯ ) ปรากฏการณ์ธรรมชาติ สงคราม การจลาจล
      และข้อพิพาทแรงงาน
    </p>
    <p>
      (3)เมื่อระบบเกิดความขัดข้องหรือมีการใช้งานระบบมากเกินกำลัง (Overload)
    </p>
    <p>
      (4)เพื่อรักษาความปลอดภัยของผู้ใช้หรือบุคคลภายนอกหรือเพื่อดำเนินภาระกิจอันเป็นประโยชน์ต่อสาธารณะในกรณีฉุกเฉิน
    </p>
    <p>
      (5)มื่อ MOVE EV X
      เห็นว่ามีความจำเป็นและเป็นการสมควรนอกจากกรณีที่ได้ระบุไว้ในข้อ (1) ถึง (4)
      ข้างต้น
    </p>
    <p>
      4.4 MOVE EV X SOFTWARE หมายถึง ซอฟต์แวร์ที่พัฒนาโดยบริษัท
      และเป็นแพลตฟอร์มในการทำงานของระบบเปลี่ยนแบตเตอรี่ โดยใช้งานแอปพลิเคชัน H
      SEM MOVE เป็นระบบการเปลี่ยนแบตเตอรี่ และบริการอื่น ๆ ที่เกี่ยวข้อง
    </p>
    <h3 class="paragraph-title">5. สิทธิในทรัพย์สินทางปัญญา</h3>
    <p>
      บริษัท มีความเป็นเจ้าของหรือมีกรรมสิทธิ์ในทรัพย์สินทางปัญญาบนแอปพลิเคชัน H
      SEM MOVE แต่เพียงผู้เดียว ผลงานหรือข้อมูลทั้งหมดบนแอปพลิเคชันนี้
      ไม่ว่าจะเป็นในรูปแบบลิขสิทธิ์ สิทธิบัตร
      เครื่องหมายการค้าและสิทธิในทรัพย์สินทางปัญญากรรมสิทธิ์หรือสิทธิอื่นๆ
      ห้ามมิให้ทำซ้ำ โอน เปลี่ยนแปลง แก้ไข เผยแพร่ หรือในรูปแบบอื่นๆ
      ไม่ว่าทั้งหมดหรือแต่บางส่วน
      โดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษรจากทางบริษัทอย่างเด็ดขาด
      ผู้ละเมิดจะถูกดำเนินคดีตามกฎหมายอย่างสูงสุด
    </p>

    <h3 class="paragraph-title">6.กฎหมายที่ใช้บังคับ</h3>
    <p>
      ผู้ใช้บริการ ควรอ่านและทำความเข้าใจข้อกำหนดและเงื่อนไขฯ นี้ อย่างละเอียด
      ถี่ถ้วน โดยรายละเอียดต่างๆ ของข้อกำหนดและเงื่อนไขฯ
      ฉบับบนี้อยู่ภายใต้บังคับกฎหมายแห่งราชอาณาจักรไทย
      ความขัดแย้งที่เกิดขึ้นจากหรือมีความเกี่ยวพันกับการบริการฯ
      หรือความขัดแย้งระหว่างผู้ใช้และ MOVE EV X ที่เกี่ยวกับบริการฯ
      จะถูกตัดสินและอยู่ภายใต้เขตอำนาจศาลแห่งราชอาณาจักรไทย
    </p>
  </div>
</template>

<script>
export default {
  name: "userAgreementTh"
};
</script>

<style scoped lang="less">
.user-agreement {
  p {
    text-indent: 2em;
    margin: 10px;
  }

  .page-title {
    text-align: center;
  }

  .paragraph-title {
    text-indent: 0;
  }

  .bottom {
    margin: 40px 20px;
    text-align: center;
  }
}
</style>
